/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';
import { LoginService } from '../../login/login.service';
import { LoginConfig, userTypes } from '../../login/login.config';
import { IceNavService, menuItem } from './ice-nav.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { provider_index } from '../../models/domain/provider_index';
import { IceTypes } from '../../models/icetypes';
import { DomainService } from '../../services/domain/domain.service';
import { Iceutility } from '../../services/iceutility';
import { SessionDataService } from '../../services/sessiondata/sessiondata.service';
import { AppService } from '../../../../../src/app/app.service';
import { BreadcrumbService } from '../../services/breadcrumb/breadcrumb.service';

declare var require: any;
let currentEnv: any = require("../../../../../env.json").currentEnv;

@Component({
  selector: 'icenav',
  templateUrl: './ice-nav.component.html',
  styleUrls: ['./ice-nav.component.scss'],
  providers: [AppService, LoginService, MessageService]
})
export class IceNavComponent implements OnInit, OnDestroy {
  @Input() brandName: string = "ICEMEDX\u2122";
  @Input() brandTrademark: boolean = true;
  @Input() navClass: string = "bg-darkblue";

  searchOn: boolean = false;
  alertsOn: boolean = false;
  menuItems: any[] = [];
  showParentLoader: boolean = false;
  timer: any;
  openSubMenuIndex: number | null = null;

  private ehrUrl: string = this.domainSvc.getEHRUrl();
  private destroy$ = new Subject<void>();
  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService,
    private domainSvc: DomainService, private sessionDataService: SessionDataService, private breadcrumbService: BreadcrumbService, private router: Router) {
  }

  ngOnInit() {
    document.body.classList.add("sidenav-toggled");

    this.sessionDataService.getData().subscribe(
      data => {

        if (Iceutility.isdefined(data)) {
          if (Iceutility.isdefined(data.menuItems)) {
            this.menuItems = data.menuItems;
          } else if (Iceutility.isdefined(data.brandName) && Iceutility.isdefined(data.brandTrademark)) {
            this.brandName = data.brandName;
            this.brandTrademark = data.brandTrademark;
          }
        }
      },
      error => {
        console.log(error);
      });

    let prodCode = LoginService.getCurrentProductCode();
    switch (prodCode) {
      case userTypes.productCodes.pcEHR:
        break;
      case userTypes.productCodes.pcHHC:
        this.brandTrademark = false;
        this.navClass = "home-health-app-background-color";
        break;
      case userTypes.productCodes.pcFIN:
        this.brandTrademark = false;
        this.navClass = "finance-app-background-color";
        break;
      case userTypes.productCodes.pcPOR:
        this.brandTrademark = false;
        this.navClass = "home-health-app-background-color";
        break;
    }

    var myDropdown = document.getElementById('routeItems');
    myDropdown.style.overflow = "visible";

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(this.router)
    ).subscribe((event) => {
      this.handleSideNavScrollStyle((event instanceof NavigationEnd) ? event.url : this.router.url, myDropdown);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBrandName(): string {
    let bName = "ICEMEDX\u2122";
    let prodCode = LoginService.getCurrentProductCode();
    switch (prodCode) {
      case userTypes.productCodes.pcEHR:
        bName = "ICEMEDX NetworkNOW EHR";
        break;
      case userTypes.productCodes.pcHHC:
        bName = "ICEMEDX\u2122 Home Healthcare";
        break;
      case userTypes.productCodes.pcFIN:
        bName = "ICEMEDX\u2122 Finance";
        break;
      case userTypes.productCodes.pcPOR:
        bName = "ICEMEDX\u2122 Portal";
        break;
    }

    let whLbl = this.loginSvc.getWhiteLabelBrandName();
    if (whLbl != null) bName = whLbl;

    return bName;
  }

  SideNavToggle(event) {
    event.preventDefault();
    document.body.classList.toggle("sidenav-toggled");
    // Todo: Revamp this code to be more angular elegant
    var na1 = document.querySelectorAll(".navbar-sidenav .nav-link-collapse");
    for (var i = 0; i < na1.length; i++)
      na1[i].classList.add("collapsed");

    var na2 = document.querySelectorAll(".navbar-sidenav .sidenav-second-level, .navbar-sidenav .sidenav-third-level");
    for (var j = 0; j < na2.length; j++) {
      na2[j].classList.remove("show");
    }
  }

  SideNavClicked(event) {
    event.preventDefault();
    var na2 = document.querySelectorAll(".navbar-sidenav .nav-link-collapse");
    for (var j = 0; j < na2.length; j++)
      na2[j].classList.remove("sidenav-toggled");

    var na1 = document.querySelectorAll(".navbar-collapse");
    for (var j = 0; j < na1.length; j++) {
      na1[j].classList.remove("show");
    }
  }

  Logout() {
    if (false == this.loginSvc.SessionLogout()) {
      this.navSvc.refresh();
      this.router.navigate([LoginConfig.getFormattedPath(this.loginSvc.app_path, 'loginflow')]);
    }
  }

  navigateToDomain(item: menuItem): void {
    let url = Iceutility.isStringUndefinedNullOrEmpty(item.routeUrl) ? "domain/" + (item.id === "hospitals" ? IceTypes.ACCOUNT_TYPE.actFacility.toString() : IceTypes.ACCOUNT_TYPE.actProvider.toString()) : item.routeUrl;
    this.router.navigate([LoginConfig.getFormattedPath(this.loginSvc.app_path, url)]);
  }

  onToolbarMenuClick(menuItem: menuItem) {
    if (!Iceutility.isdefined(menuItem) || Iceutility.isStringUndefinedNullOrEmpty(menuItem.routeUrl)) {
      return;
    }
    this.breadcrumbService.clearSessionHistory();
    this.appSvc.closePatient();
    this.appSvc.openAccount(menuItem["domain"], Iceutility.toLong(menuItem["domainType"]));

    if (!Iceutility.isStringUndefinedNullOrEmpty(menuItem.routeUrlOverride)) {
      let subDom = this.appSvc.getCurrentPatient();
      let tourl: string = this.navSvc.buildRoute(menuItem.routeUrlOverride, menuItem.external, menuItem["domain"], menuItem["domainType"], subDom, menuItem["productCode"]);
      location.href = tourl;
    }
    else {
      this.router.navigate([this.navSvc.buildRoute(menuItem.routeUrl, false)]);
    }
  }

  onSideNavMenuClick(menuItem: menuItem) {
    if (!Iceutility.isStringUndefinedNullOrEmpty(menuItem.routeUrlOverride)) {
      let dom = menuItem["domain"];
      if (dom == null || dom.length == 0)
        dom = this.appSvc.getCurrentAccount();

      let domType = menuItem["domaintype"];
      if (domType == null || domType.length == 0)
        domType = this.appSvc.getCurrentAccountType();

      let subDom = this.appSvc.getCurrentPatient();

      let tourl: string = this.navSvc.buildRoute(menuItem.routeUrlOverride, menuItem.external, dom, domType, subDom, menuItem["productCode"]);
      location.href = tourl;
    }
    else {
      this.router.navigate([menuItem.routeUrl]);
    }
  }

  getContent(menuItem: menuItem) {
    menuItem.children = [];
    this.showParentLoader = true;

    switch (menuItem.id) {
      case "providers":
      case "hospitals":
        this.domainSvc.getProviders().subscribe(
          data => {
            let prvs = data;

            if (prvs) {
              let filteredProviders = prvs.filter(prov => prov.account_type === (menuItem.id === "providers" ? IceTypes.ACCOUNT_TYPE.actProvider.toString() : IceTypes.ACCOUNT_TYPE.actFacility.toString()));

              for (let ipro = 0; ipro < filteredProviders.length; ipro++) {
                let proIdx: provider_index = <provider_index>filteredProviders[ipro];
                if (proIdx == null) continue;
                proIdx.account_type = Iceutility.toLong(proIdx.account_type);

                let subMenuItems = this.getSubMenuItems();

                for (let i = 0; i < subMenuItems.length; i++) {
                  let item = subMenuItems[i];
                  item.routeUrl.replace("{domain}", proIdx.trans_account).replace("{domainType}", proIdx.account_type.toString());
                  item["domain"] = proIdx.trans_account;
                  item["domainType"] = proIdx.account_type.toString();
                }

                if (menuItem.children.find(mi => mi.id === proIdx.trans_account)) continue;

                menuItem.children.push({
                  children: subMenuItems,
                  iconClassToAdd: "",
                  id: proIdx.trans_account,
                  parentId: "",
                  routeUrl: "",
                  routeUrlOverride: "",
                  text: menuItem.id === "providers" ? `${proIdx.first_name} ${proIdx.last_name}` : proIdx.getdisplayname(true),
                  hasChildren: true,
                  external: false,
                  productCode: ""
                });
                menuItem["domainType"] = proIdx.account_type.toString();
              }
            }

            this.showParentLoader = false;
          },
          error => {
            console.log(JSON.stringify(this.domainSvc.getLastErrors()));
            this.showParentLoader = false;
          });
    }
    this.openSubMenuIndex = null;
  }

  getParentMenuStyle() {
    if (!Iceutility.isMobileDevice()) {
      return document.body.classList.contains("sidenav-toggled") ? {
        'margin-left': '300px',
        'top': '10px'
      } :
        {
          'margin-left': '125px',
          'top': '10px'
        };
    }
    return {
      'padding-left': '64px',
      'top': '10px'
    }
  }

  getMenuStyle() {
    var elements = document.getElementsByClassName("mat-menu-panel");
    if (elements != null && elements.length > 0) {
      elements[0].setAttribute("style", "max-width: 500px;");
    }

    var cdkOverlayContainer = document.getElementsByClassName("cdk-overlay-connected-position-bounding-box");
    if (cdkOverlayContainer != null && cdkOverlayContainer.length > 0) {
      cdkOverlayContainer[0].setAttribute("style", "top: 125px;");
    }

    if (!Iceutility.isMobileDevice()) {
      return document.body.classList.contains("sidenav-toggled") ? {
        'width': 'auto',
        'margin-left': '260px'
      } :
        {
          'width': '195px',
          'margin-left': '85px'
        };
    }
    return {
      'width': 'auto',
      'padding-left': '0'
    };
  }

  getSubMenuItems(): menuItem[] {
    // To do Patient and Encounter links need to be reserved for the EHR product code only
    return [
      { text: "Dashboard", id: "dashboard", routeUrl: "dashboard", external: false, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: "", productCode: "" },
      { text: "Patient Search", id: "search", routeUrl: this.ehrUrl + "Search?domain={domain}&domaintype={domainType}&key=", external: true, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: this.ehrUrl + "Search?domain={domain}&domaintype={domainType}&key=", productCode: userTypes.productCodes.pcEHR },
      { text: "Patient Schedule", id: "schedule", routeUrl: this.ehrUrl + "Schedule?domain={domain}&domaintype={domainType}&vw=dayView&date=&todate=", external: true, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: this.ehrUrl + "Schedule?domain={domain}&domaintype={domainType}&vw=dayView&date=&todate=", productCode: userTypes.productCodes.pcEHR },
      { text: "Encounter Status", id: "encounters", routeUrl: this.ehrUrl + "Status?domain={domain}&domaintype={domainType}", external: true, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: this.ehrUrl + "Status?domain={domain}&domaintype={domainType}", productCode: userTypes.productCodes.pcEHR },
      { text: "Network Profile", id: "domainprofile", routeUrl: "domainprofile/provider", external: false, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: "", productCode: "" },
      { text: "Accounting Summary", id: "accounting", routeUrl: "accounting/summary", external: true, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: "", productCode: "" },
      { text: "Inventory", id: "accounting", routeUrl: "accounting/inventory", external: true, children: null, hasChildren: false, iconClassToAdd: "", parentId: "", routeUrlOverride: "", productCode: "" }
    ];
  }

  isMobileDevice(): boolean {
    return Iceutility.isMobileDevice();
  }

  onDropdownToggle(index: number): void {
    if (this.openSubMenuIndex === index) {
      this.openSubMenuIndex = null;
    } else {
      this.openSubMenuIndex = index;
    }
  }

  onDropdownClosed(): void {
    this.openSubMenuIndex = null;
  }

  private handleSideNavScrollStyle(url, dropdown) {
    if (url.indexOf("dashboard") >= 0 || url.indexOf("members") >= 0 || url.indexOf("reports") >= 0 || url.indexOf("domain/") >= 0  || url === "/") {
      dropdown.style.overflow = "visible";
    } else {
      dropdown.style.removeProperty("overflow");
      dropdown.style.overflowY = "scroll";
    }
  }
}
